import React, { useState } from 'react';
import { ModalStepper } from 'src/components/Proposal/ModalStepper';

import { Card, TextInput, Textarea, Button } from '@sravni/react-design-system';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { required, validate } from '../../../utils/validationFrom';
import { FromBlock, Form, Field, FromGroup } from '../Form';

import styles from './styles.module.scss';

export interface IShareIdeaForm {
  fio?: string;
  contact?: string;
  comment?: string;
}

interface Props {
  onSubmit?: (values: NonNullable<IShareIdeaForm>) => void;
}

const validateConfig = {
  fio: [required],
  contact: [required],
  comment: [required],
};

const stepFields = ['comment', 'fio', 'contact'];

export const ShareIdeaForm: React.FC<Props> = ({ onSubmit }) => {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useBoolean(false);
  const [step, setStep] = useState(0);

  return (
    <Card className={styles.card}>
      <Form onSubmit={onSubmit} validateConfig={validateConfig}>
        {({ fields, errors, handleChange, setError }) => {
          const onFocus = (e: React.FormEvent) => {
            //@ts-ignore
            const newStep = stepFields.findIndex((el) => el === e.target.name);

            setStep(newStep);
            isMobile && setVisible.on();
          };

          const handleStepChange = (nextStep: number) => {
            const key = stepFields[step];
            const validateResult = validate(validateConfig[key])(Object.values(fields)[step]);
            if (!validateResult || nextStep < step) {
              setStep(nextStep);
            } else {
              setError(key, validateResult);
            }
          };
          return (
            <>
              <FromBlock title="Опишите идею статьи">
                <Field error={errors['comment']}>
                  <Textarea
                    name="comment"
                    onChange={handleChange}
                    onFocus={onFocus}
                    value={fields.comment}
                    className={styles['text-area']}
                    rows={isMobile ? 8 : 5}
                    placeholder="Например: у меня была только одна банковская карта, потом я узнал, что есть другая карта с милями, потом — про карту с бонусами. Теперь у меня 10 разных карт, я с ними экономлю, покупая технику, оплачивая коммуналку, заказывая продукты. "
                  />
                </Field>
              </FromBlock>
              <FromBlock title="Ваше имя и контакт для связи">
                <FromGroup>
                  <Field error={errors['fio']}>
                    <TextInput
                      label="Как к вам обращаться"
                      name="fio"
                      onChange={handleChange}
                      onFocus={onFocus}
                      value={fields.fio}
                    />
                  </Field>
                  <Field error={errors['contact']}>
                    <TextInput
                      name="contact"
                      label="Подойдут telegram, почта"
                      onFocus={onFocus}
                      onChange={handleChange}
                      value={fields.contact}
                    />
                  </Field>
                </FromGroup>
              </FromBlock>
              <Button type="submit" className={styles.button} variant="primary">
                Отправить
              </Button>

              <ModalStepper
                step={step}
                onChange={handleStepChange}
                visible={visible}
                onClose={() => {
                  setVisible.off();
                  setStep(0);
                }}
              >
                <ModalStepper.Step title="Опишите идею статьи">
                  <Field error={errors['comment']}>
                    <Textarea name="comment" onChange={handleChange} value={fields.comment} />
                  </Field>
                </ModalStepper.Step>

                <ModalStepper.Step title="Как к вам обращаться">
                  <Field error={errors['fio']}>
                    <TextInput name="fio" onChange={handleChange} value={fields.fio} />
                  </Field>
                </ModalStepper.Step>

                <ModalStepper.Step title="Контакт для связи">
                  <Field error={errors['contact']}>
                    <TextInput name="contact" onChange={handleChange} value={fields.contact} />
                  </Field>
                </ModalStepper.Step>
              </ModalStepper>
            </>
          );
        }}
      </Form>
    </Card>
  );
};
